let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ejpJH")).then(() => parcelRequire('9Ea2W'));